import React, { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import ChatSimulation from './components/ChatSimulation';
import FeaturesShowcase from './components/FeaturesShowcase';
import IntegrationEcosystem from './components/IntegrationEcosystem';
import SuccessStories from './components/SuccessStories';
import CTASection from './components/CTASection';

const HeroLanding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0E27]">
      <Header />
      
      <main>
        <HeroSection />
        <ChatSimulation />
        <FeaturesShowcase />
        <IntegrationEcosystem />
        <SuccessStories />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default HeroLanding;